export * from './room.model';



// WEBPACK FOOTER //
// ./src/app/_services/room/index.ts